import axios from '../axiosConfig';

var deployPath = process.env.REACT_APP_SERVER_URL || "";

export default {

  getOccupations: (productCode) => {
    return axios.get(`${deployPath}/api/pyme/occupations/${productCode}`)
    .then(occupations => {
      return occupations.data;
    })
    .catch(error => {
      // console.log(error);
    });
  },

  getCoveragePlans: () => {
    return axios.get(`${deployPath}/api/pyme/coveragePlans`)
    .then(plans => {
      return plans.data;
    })
    .catch(error => {
      // console.log(error);
    });
  },

  getCoverageModules: (productCode) => {
    return axios.get(`${deployPath}/api/pyme/coverageModules/${productCode}`)
    .then(modules => {
      return modules.data;
    })
    .catch(error => {
      // console.log(error);
    });
  },

  getQuotation: (request) => {
    return axios.post(`${deployPath}/api/pyme/quotation/`, request)
      .then(quotation => {
        return quotation.data;
      })
      .catch(error => {
        // console.log(error);
      });
  },
};
